module.exports = __webpack_public_path__ + "static/media/Visa_Master_Discover_Amex.4ad0cfd5.png";